import DIApi from './_diApi';

class CurrencyAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'currencys';
}

export default new CurrencyAPI();
